import styled from 'styled-components'

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  padding: 10px;
`

export const InfoContainer = styled.div`
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.gray};
  padding: 10px;
  color: ${({ theme }) => theme.colors.darkGray};
  margin-bottom: 10px;
  text-align: center;

  & h6 {
    margin: 0;
  }
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 1 100%;
`
